import React from 'react';
import classes from './landingCooperation.module.css';

const howItWorks = [
  {
    id: 1,
    text: 'اطلب وعبئ الفورم',
  },
  {
    id: 2,
    text: 'راح يتواصل معك المرشد التعليمي لفهم احتياجكم خلال فترة قدرها 24 ساعة بحد أقصى كاتصال',
  },
  {
    id: 3,
    text: 'بعد فهم المطلوب سيتم تحديد موعد أول حصة مع الطالب',
  },
  {
    id: 4,
    text: 'بدء الدراسة عن بعد عبر التطبيق او جهاز الكمبيوتر',
  },
];
const DownloadApp = () => {
  return (
    <section className={classes['downloadapp-section']}>
      <div className={classes['downloadapp-small-container']}>
        <div className={classes['downloadapp-details']}>
          <h2>
            كيف يعمل <span>فهيم</span>
          </h2>
          <ul className={classes['downloadapp-list']}>
            {howItWorks.map((item) => (
              <li key={item.id}>
                <p>{item.text}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className={classes['downloadapp-image']}>
          <img
            src="/assets/icons/cooperation/downloadapp/Download-app.svg"
            alt="phone"
          />
        </div>
      </div>
    </section>
  );
};

export default DownloadApp;
